import { dispatch } from "../../state/store";
import { pushReleaseNotesMedia, pushReleaseNotesThumbnails } from "../../state/ducks";

import s3ImageService from "../image/s3ImageService";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_MERCURY_API_URL;

const getRequestData = () => {
  return `${apiUrl}/release-notes`;
};

const fetchReleaseNotes = async (version) => {
  const url = getRequestData();
  const result = await httpClient.get(`${url}?version=${version}`);

  if (result?.data?.data) {
    const releaseNotes = result?.data?.data;

    const mediaData = result.data.data?.mediaData;
    const thumbnail = result.data.data?.thumbnail;

    const mediaPromises = [];

    if (mediaData) {
      mediaPromises.push(fetchReleaseNotesMedia(mediaData));
    }

    if (thumbnail) {
      mediaPromises.push(fetchReleaseNotesMedia(thumbnail, true));
    }

    await Promise.all(mediaPromises);

    return releaseNotes;
  }
};

const createReleaseNotes = async (releaseNotes) => {
  const url = getRequestData();

  const result = await httpClient.post(url, { data: releaseNotes });
  const mediaUrls = result?.data?.data?.mediaData;
  const thumbnailUrls = result?.data?.data?.thumbnail;

  return { mediaUrls, thumbnailUrls };
};

const updateReleaseNotes = async (releaseNotes) => {
  const url = getRequestData();

  const result = await httpClient.put(url, { data: releaseNotes });
  const mediaUrls = result?.data?.data?.mediaData;
  const thumbnailUrls = result?.data?.data?.thumbnail;

  return { mediaUrls, thumbnailUrls };
};

const deleteReleaseNotes = async (version) => {
  const url = getRequestData();
  const result = await httpClient.remove(`${url}?version=${version}`);

  return result;
};

const fetchReleaseNotesMedia = async (iconsData, isThumbnail) => {
  const res = await Promise.all(
    iconsData?.map((config) => {
      return downloadImage(config, isThumbnail);
    })
  );

  return res;
};

const downloadImage = async (config, isThumbnail) => {
  const { id, media: mediaUrl, mediaExtension } = config ?? {};

  if (id && mediaUrl && mediaExtension) {
    const { imageFile, imageSrc } = await s3ImageService.downloadImage(mediaUrl, mediaExtension);

    if (imageFile && imageSrc) {
      const releaseNoteImage = { id, mediaUrl, mediaExtension, imageFile, imageSrc };

      if (isThumbnail) {
        dispatch(pushReleaseNotesThumbnails(releaseNoteImage));
      } else {
        dispatch(pushReleaseNotesMedia(releaseNoteImage));
      }

      return imageFile;
    }
  }
};

const releaseNotesService = {
  fetchReleaseNotes,
  createReleaseNotes,
  updateReleaseNotes,
  deleteReleaseNotes
};

export default releaseNotesService;
